export default __webpack_public_path__ + "284419a531f75ec5aaa3b61d3722e79e.png";